import { defineAsyncComponent, type App, type Plugin as VuePlugin } from 'vue';

export type Plugin<Options = any[]> = VuePlugin<Options>;

export interface ComponentType {
  name: string;
  component: ReturnType<typeof defineAsyncComponent>;
}

export const toPlugin = (components: ComponentType[]): Plugin<[]> => {
  return {
    install: (app: App, _?: Record<string, any>) => {
      components.forEach(({ name, component }) => {
        app.component(name, component);
      });
    },
  };
};

export default toPlugin;
